import { useContext } from 'react';
import { ComboBoxOptionGroupContext } from './ComboBoxOptionGroupContext.js';

/** @typedef { import('@utahdts/utah-design-system').ComboBoxOptionGroupContextValue} ComboBoxOptionGroupContextValue */

/** @returns {ComboBoxOptionGroupContextValue} */
export function useComboBoxOptionGroupContext() {
  return useContext(ComboBoxOptionGroupContext);
}
